import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';

import { LoadingSpaceType } from 'src/app/core/types';
import { Project } from '../../../../core/objects/project';
import { maxErrorKey } from '../../../../shared/validators/validators';
import { Subscription } from 'rxjs';

@Component({
    selector: 'gl-loading-space-cooler',
    templateUrl: './loading-space-cooler.component.html',
    styleUrls: ['./loading-space-cooler.component.scss'],
    standalone: false
})
export class LoadingSpaceCoolerComponent implements OnInit, OnChanges, OnDestroy {
  @Output() public submitEvent = new EventEmitter();
  @Input() public chosenLoadingSpace: LoadingSpaceType;
  @Input() public loadingSpace: LoadingSpaceType;
  @Input() public typeLoadingSpace: number;
  @Input() public isEdit = false;
  @ViewChild('f', { static: false }) public formEl: FormGroupDirective;
  @Input() public project: Project;
  public form: CoolerForm;
  public loadingSpaces: LoadingSpaceType[];
  public isTrailerOpen = true;
  public isSemitrailerOpen = false;
  public isSet = false;
  public loadingSpaceMod: LoadingSpaceType;
  private pattern = '^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$';
  private subscription: Subscription;

  constructor() {
    this.form = this.generateLoadingSpaceForm();
  }

  public reload(): void {
    this.onChosen(this.chosenLoadingSpace);
  }

  private updateSpaceModChange(): void {
    this.loadingSpaceMod = {
      name: this.loadingSpace.name,
      length: this.loadingSpace.length,
      width: this.loadingSpace.width,
      height: this.loadingSpace.height,
      limit: this.loadingSpace.limit,
      length1: this.loadingSpace.length1,
      width1: this.loadingSpace.width1,
      height1: this.loadingSpace.height1,
      limit1: this.loadingSpace.limit1,
      set: true,
      type: this.loadingSpace.type,
      id: null,
      unit: this.loadingSpace.unit,
      axis: [],
      useInRecommendation: null,
      wheelTrailerWidth: null,
      wheelTrailerHeight: null,
      wheelTrailerLength: null,
      wheelTrailerDistance: null,
      wheelSemiTrailerWidth: null,
      wheelSemiTrailerHeight: null,
      wheelSemiTrailerLength: null,
      wheelSemiTrailerDistance: null,
      coolerTrailerWidth: this.loadingSpace.coolerTrailerWidth
        ? this.loadingSpace.coolerTrailerWidth
        : null,
      coolerTrailerHeight: this.loadingSpace.coolerTrailerHeight
        ? this.loadingSpace.coolerTrailerHeight
        : null,
      coolerTrailerLength: this.loadingSpace.coolerTrailerLength
        ? this.loadingSpace.coolerTrailerLength
        : null,
      coolerTrailerFloorHeight: this.loadingSpace.coolerTrailerFloorHeight
        ? this.loadingSpace.coolerTrailerFloorHeight
        : null,
      coolerSemiTrailerWidth: this.loadingSpace.coolerSemiTrailerWidth
        ? this.loadingSpace.coolerSemiTrailerWidth
        : null,
      coolerSemiTrailerHeight: this.loadingSpace.coolerSemiTrailerHeight
        ? this.loadingSpace.coolerSemiTrailerHeight
        : null,
      coolerSemiTrailerLength: this.loadingSpace.coolerSemiTrailerLength
        ? this.loadingSpace.coolerSemiTrailerLength
        : null,
      coolerSemiTrailerFloorHeight: this.loadingSpace.coolerSemiTrailerFloorHeight
        ? this.loadingSpace.coolerSemiTrailerFloorHeight
        : null,
      varioTrailerFloorHeight: null,
      varioSemiTrailerFloorHeight: null,
    };
  }

  private updateSpaceMod(): void {
    const floorHeight =
      this.form.get('floorHeight').value !== null
        ? parseFloat(this.form.get('floorHeight').value)
        : null;
    const width =
      this.form.get('width').value !== null ? parseFloat(this.form.get('width').value) : null;
    const height =
      this.form.get('height').value !== null ? parseFloat(this.form.get('height').value) : null;
    const length =
      this.form.get('length').value !== null ? parseFloat(this.form.get('length').value) : null;
    const floorHeight2 =
      this.form.get('floorHeight2').value !== null
        ? parseFloat(this.form.get('floorHeight2').value)
        : null;
    const width2 =
      this.form.get('width2').value !== null ? parseFloat(this.form.get('width2').value) : null;
    const height2 =
      this.form.get('height2').value !== null ? parseFloat(this.form.get('height2').value) : null;
    const length2 =
      this.form.get('length2').value !== null ? parseFloat(this.form.get('length2').value) : null;
    this.loadingSpaceMod = {
      name: this.loadingSpace.name,
      length: this.loadingSpace.length,
      width: this.loadingSpace.width,
      height: this.loadingSpace.height,
      limit: this.loadingSpace.limit,
      length1: this.loadingSpace.length1,
      width1: this.loadingSpace.width1,
      height1: this.loadingSpace.height1,
      limit1: this.loadingSpace.limit1,
      set: true,
      type: this.loadingSpace.type,
      id: null,
      unit: this.loadingSpace.unit,
      axis: [],
      useInRecommendation: null,
      wheelTrailerWidth: null,
      wheelTrailerHeight: null,
      wheelTrailerLength: null,
      wheelTrailerDistance: null,
      wheelSemiTrailerWidth: null,
      wheelSemiTrailerHeight: null,
      wheelSemiTrailerLength: null,
      wheelSemiTrailerDistance: null,
      coolerTrailerWidth: width,
      coolerTrailerHeight: height,
      coolerTrailerLength: length,
      coolerTrailerFloorHeight: floorHeight,
      coolerSemiTrailerWidth: width2,
      coolerSemiTrailerHeight: height2,
      coolerSemiTrailerLength: length2,
      coolerSemiTrailerFloorHeight: floorHeight2,
      varioTrailerFloorHeight: null,
      varioSemiTrailerFloorHeight: null,
    };
  }

  public ngOnInit() {
    this.updateSpaceModChange();
    this.subscription = this.form.valueChanges.subscribe((changes) => {
      if (
        (changes.width && changes.height && changes.length && changes.floorHeight) ||
        (changes.floorHeight2 && changes.width2 && changes.height2 && changes.length2)
      ) {
        this.addMaxValidators();
        this.updateSpaceMod();
      }
      this.onSubmit();
    });
    this.isSet = this.loadingSpace && this.loadingSpace.set;
    this.onChosen(this.loadingSpace);
    if (this.isEdit) {
      this.form.enable();
    } else {
      this.form.disable();
    }
  }

  private setControlValidator(name: string, max: number): void {
    this.form.controls[name].clearValidators();
    this.form
      .get(name)
      .setValidators([
        Validators.min(0),
        Validators.pattern(this.pattern),
        maxErrorKey(max, 'coolerMax'),
        Validators.required,
      ]);
    this.form.controls[name].updateValueAndValidity({ onlySelf: true, emitEvent: false });
  }

  private addMaxValidators(): void {
    if (!this.loadingSpace) {
      return;
    }
    if (this.loadingSpace.width && this.loadingSpace.height && this.loadingSpace.length) {
      const maxWidth = this.loadingSpace.width;
      const maxHeight = this.loadingSpace.height - this.form.get('floorHeight').value;
      const maxLength = this.loadingSpace.length;
      const maxFloorHeight = this.loadingSpace.height - this.form.get('height').value;
      this.setControlValidator('height', maxHeight);
      this.setControlValidator('width', maxWidth);
      this.setControlValidator('length', maxLength);
      this.setControlValidator('floorHeight', maxFloorHeight);
    }
    if (
      this.loadingSpace.set &&
      this.loadingSpace.width1 &&
      this.loadingSpace.height1 &&
      this.loadingSpace.length1
    ) {
      const maxWidth2 = this.loadingSpace.width1;
      const maxHeight2 = this.loadingSpace.height1 - this.form.get('floorHeight2').value;
      const maxLength2 = this.loadingSpace.length1;
      const maxFloorHeight2 = this.loadingSpace.height1 - this.form.get('height2').value;
      this.setControlValidator('height2', maxHeight2);
      this.setControlValidator('width2', maxWidth2);
      this.setControlValidator('length2', maxLength2);
      this.setControlValidator('floorHeight2', maxFloorHeight2);
    }
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (
      changes.loadingSpace &&
      changes.loadingSpace.currentValue &&
      changes.loadingSpace.currentValue.width &&
      changes.loadingSpace.currentValue.height &&
      changes.loadingSpace.currentValue.length
    ) {
      this.updateSpaceModChange();
      this.addMaxValidators();
    }
    if (
      changes.chosenLoadingSpace &&
      changes.chosenLoadingSpace.currentValue !== changes.chosenLoadingSpace.previousValue
    ) {
      this.onChosen(changes.chosenLoadingSpace.currentValue as LoadingSpaceType);
    }
    if (changes.typeLoadingSpace && !changes.typeLoadingSpace.firstChange) {
      this.form.reset(undefined, { onlySelf: true, emitEvent: false });
    }
    this.isSet =
      changes.loadingSpace &&
      changes.loadingSpace.currentValue &&
      (changes.loadingSpace.currentValue.set as boolean);
    if (changes.isEdit && changes.isEdit.currentValue) {
      this.isEdit = true;
      this.form.enable();
    } else if (changes.isEdit && !changes.isEdit.currentValue) {
      this.isEdit = false;
      this.form.disable();
    }
  }

  public onSubmit(): void {
    // if (this.form.dirty) {
    //   this.formEl?.onSubmit(undefined);
    // }
    const isLoadingSpace = this.loadingSpace && this.loadingSpace.width && this.loadingSpace.height;
    const isTrailerValid =
      this.form.get('length').valid &&
      this.form.get('height').valid &&
      this.form.get('width').valid &&
      this.form.get('floorHeight').valid;
    const isSemiTrailerValid =
      this.form.get('length2').valid &&
      this.form.get('height2').valid &&
      this.form.get('width2').valid &&
      this.form.get('floorHeight2').valid;
    if (isLoadingSpace && (isSemiTrailerValid || isTrailerValid)) {
      this.submitEvent.emit(this.form.value);
    }
  }

  public onChosen(loadingSpace: LoadingSpaceType): void {
    if (!loadingSpace) {
      return;
    }
    this.form.patchValue({
      length: loadingSpace.coolerTrailerLength ? loadingSpace.coolerTrailerLength : null,
      height: loadingSpace.coolerTrailerHeight ? loadingSpace.coolerTrailerHeight : null,
      width: loadingSpace.coolerTrailerWidth ? loadingSpace.coolerTrailerWidth : null,
      floorHeight: loadingSpace.coolerTrailerFloorHeight
        ? loadingSpace.coolerTrailerFloorHeight
        : null,
      length2: loadingSpace.coolerSemiTrailerLength ? loadingSpace.coolerSemiTrailerLength : null,
      height2: loadingSpace.coolerSemiTrailerHeight ? loadingSpace.coolerSemiTrailerHeight : null,
      width2: loadingSpace.coolerSemiTrailerWidth ? loadingSpace.coolerSemiTrailerWidth : null,
      floorHeight2: loadingSpace.coolerSemiTrailerFloorHeight
        ? loadingSpace.coolerSemiTrailerFloorHeight
        : null,
    });
  }

  public formReset(): void {
    this.form.patchValue({
      length: null,
      height: null,
      width: null,
      floorHeight: null,
      length2: null,
      height2: null,
      width2: null,
      floorHeight2: null,
    });
    this.submitEvent.emit(this.form.value);
  }

  public openTab(tabName: string): void {
    this.isTrailerOpen = false;
    this.isSemitrailerOpen = false;
    switch (tabName) {
      case 'trailer':
        this.isTrailerOpen = true;
        break;
      case 'semitrailer':
        this.isSemitrailerOpen = true;
        break;
    }
  }

  private generateLoadingSpaceForm(): CoolerForm {
    return new UntypedFormGroup({
      length: new UntypedFormControl(null),
      width: new UntypedFormControl(null),
      height: new UntypedFormControl(null),
      floorHeight: new UntypedFormControl(null),
      length2: new UntypedFormControl(null),
      width2: new UntypedFormControl(null),
      height2: new UntypedFormControl(null),
      floorHeight2: new UntypedFormControl(null),
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}

interface CoolerForm extends UntypedFormGroup {
  value: {
    length: number;
    height: number;
    width: number;
    floorHeight: number;
    length2: number;
    height2: number;
    width2: number;
    floorHeight2: number;
  };
}
